import type { App } from 'vue';
import { useUserInfo } from '/@/stores/userInfo';
import { useChatStore } from '/@/stores/chat';
import { Message } from 'winbox-ui-next';
import { judementSameArr } from '/@common/utils/arrayOperation';
import { i18n } from '/@common/i18n';
import mittBus from '/@common/utils/mitt';
const chatStore = useChatStore();

/**
 * 用户权限指令
 * @directive 单个权限验证（v-auth="xxx"）
 * @directive 多个权限验证，满足一个则显示（v-auths="[xxx,xxx]"）
 * @directive 多个权限验证，全部满足则显示（v-auth-all="[xxx,xxx]"）
 */
export function authDirective(app: App) {
	// 单个权限验证（v-auth="xxx"）
	app.directive('auth', {
		mounted(el, binding) {
			const stores = useUserInfo();
			if (!stores.userInfos.authBtnList.some((v: string) => v === binding.value)) el.parentNode.removeChild(el);
		},
	});
	// 多个权限验证，满足一个则显示（v-auths="[xxx,xxx]"）
	app.directive('auths', {
		mounted(el, binding) {
			let flag = false;
			const stores = useUserInfo();
			stores.userInfos.authBtnList.map((val: string) => {
				binding.value.map((v: string) => {
					if (val === v) flag = true;
				});
			});
			if (!flag) el.parentNode.removeChild(el);
		},
	});
	// 多个权限验证，全部满足则显示（v-auth-all="[xxx,xxx]"）
	app.directive('auth-all', {
		mounted(el, binding) {
			const stores = useUserInfo();
			const flag = judementSameArr(binding.value, stores.userInfos.authBtnList);
			if (!flag) el.parentNode.removeChild(el);
		},
	});
}
function replaceUrl(event: any) {
	let value = event.target.value;
	let urlRegex = /(https?:\/\/[^\s]+)/g;
	if (value.match(urlRegex) && chatStore.modelVersion == 'YAYI-V2.5-30B-8K') {
		event.preventDefault();
		Message.info({
			id: 'infoMessage',
			content: i18n.global.t('common.tips.infoMessage'),
		});
		mittBus.emit('changeTextValue', '');
	}
}
// 禁止input输入URL链接指令(2.5模型处理)
export function defaultUrl(app: App) {
	app.directive('preventUrl', {
		mounted(el, binding) {
			el.addEventListener('input', (event: any) => {
				replaceUrl(event);
			});
		},
		unmounted(el) {
			el.removeEventListener('input', replaceUrl);
		},
	});
}

function safeHtmlDirective(el, binding) {
	// 允许渲染的标签
	const allowedTags = ['yayi-url'];
	const container = document.createElement('div');
	container.innerHTML = binding.value;

	function processNode(node) {
		if (node.nodeType === Node.ELEMENT_NODE) {
			if (!allowedTags.includes(node.tagName.toLowerCase())) {
				const textNode = document.createTextNode(node.outerHTML);
				node.replaceWith(textNode);
			} else {
				Array.from(node.childNodes).forEach(processNode);
			}
		}
	}

	Array.from(container.childNodes).forEach(processNode);
	el.innerHTML = container.innerHTML;
}
export function safeHtml(app: App) {
	app.directive('safe-html', {
		mounted(el, binding) {
			safeHtmlDirective(el, binding);
		},
		updated(el, binding) {
			safeHtmlDirective(el, binding);
		},
	});
}


export function clickOutSide(app: App) {
	app.directive('click-outside', {
		mounted: function (el, binding) {
			el.clickOutsideEvent = function (event) {
				if (!(el == event.target || el.contains(event.target))) {
					binding.value(event, el)
				}
			}
			document.addEventListener("click", el.clickOutsideEvent)
		},
		unmounted: function (el) {
			document.removeEventListener("click", el.clickOutsideEvent)
		},
	})
  }